<template>
    <div>
        <b-button :disabled="paymentPlan.length == 0" @click="show = true">Cancel</b-button>

        <b-modal id="payment-plan-cancel" v-model="show" size="lg" title="Cancel Plan" no-fade hide-footer>
            <b-list-group>
                <b-list-group-item><b>Customer A#</b>: {{ ActivePaymentPlan.dpiCustNbr }}</b-list-group-item>
                <b-list-group-item><b>Customer Name</b>: {{ ActivePaymentPlan.custName }} </b-list-group-item>
                <b-list-group-item><b>Plan</b>: {{ ActivePaymentPlan.paymentPlan }}</b-list-group-item>
                <b-list-group-item><b>Start Date</b>: {{ new Date(ActivePaymentPlan.startDate).toLocaleDateString() }}</b-list-group-item>
                <b-list-group-item><b>Amount</b>: ${{ Number.parseFloat(ActivePaymentPlan.balance).toFixed(2) }}</b-list-group-item>
                <textarea :class="{'input--error':this.CancelMessage.length > this.CancelMessageLimit}" v-model="CancelMessage" placeholder="add cancel notes"></textarea>
                <b-list-group-item>{{ charactersLeft }}</b-list-group-item>
            </b-list-group>
            
            <b-button class="mt-3" block @click="validateCancel">Cancel Payment Plan</b-button>
            <b-button class="mt-3" block @click="$bvModal.hide('payment-plan-cancel')">Close</b-button>
        </b-modal>
    </div>

</template>

<script>


    import Repo from '../repo';

    export default {
        name: 'PaymentPlanCancelModal',
        props: {
            paymentPlan: Array,
            user: String
        },
        data() {
            return {
                ANumber: '',
                CustomerName: '',
                PaymentPlanName: '',
                StartDate: '',
                Amount: '',
                CancelMessage: '',
                CancelMessageLimit: 100,
                show: false
            }
        },
        mounted: async function () {

        },
        methods: {
            validateCancel: async function () {
                if (this.CancelMessage.length <= this.CancelMessageLimit) {
                    await this.cancelPaymentPlan();
                    this.show = false;
                    this.$emit('close');
                }
                return;
            },
            cancelPaymentPlan: async function () {
                return new Promise((resolve, reject) => {
                    this.$store.dispatch('shell/turnOnSpinner', true);
                    Repo.PaymentPlanService.CancelPaymentPlan({
                        paymentPlanNumber: this.paymentPlan[0].pmtPlanNbr,
                        customerNbr: this.paymentPlan[0].customerNbr,
                        notes: (this.CancelMessage) ? this.CancelMessage : 'Payment Plan Cancelled',
                        userUpdate: this.user
                    }).then(res => {
                        this.$store.dispatch('shell/turnOffSpinner', false);
                        resolve(true);
                    });
                })
            },
        },
        computed: {
            charactersLeft() {
                var char = this.CancelMessage.length;
                var limit = this.CancelMessageLimit;

                return (limit - char) + " / " + limit + " characters remaining";
            },
            ActivePaymentPlan() {
                var plan = {};
                if (this.paymentPlan.length > 0) {
                    plan.dpiCustNbr = this.paymentPlan[0].dpiCustNbr;
                    plan.custName = this.paymentPlan[0].custName;
                    plan.paymentPlan = this.paymentPlan[0].paymentPlan;
                    plan.startDate = this.paymentPlan[0].startDate;
                    plan.balance = this.paymentPlan[0].balance;
                } else {
                    plan.dpiCustNbr = '';
                    plan.custName = '';
                    plan.paymentPlan = '';
                    plan.startDate = '';
                    plan.balance = '';
                }
                return plan
            }
        },
        watch: {
        }
    };
</script>

<style scoped>
    .input--error {
        border-color: red;
        background-color: tomato;
    }
</style>